import { useCallback, useState } from "react";

export const useBool = (initialValue?: boolean) => {
  const [bool, setBool] = useState<boolean>(Boolean(initialValue));
  const toggle = useCallback(() => setBool((bool) => !bool), []);
  const changeToTrue = useCallback(() => setBool(true), []);
  const changeToFalse = useCallback(() => setBool(false), []);
  return { bool, toggle, changeToTrue, changeToFalse };
};
